


























































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            popup: false,
        }
    },

    methods: {
        clicked: function() {
            const body = document.body;
            const open = body.style.overflow === 'hidden';
            open && !this.popup && this.$emit('clicked');
        },

        togglePopup: function() {
            this.popup = !this.popup;
        }
    },

    mounted() {
        this.$root.$on('popup-call', this.togglePopup);
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Menu extends Vue {}

